import { useTranslation } from "react-i18next"
import { Bell, Calendar, Cardholder, Chart, Global, Shield, Smartphone, UsersGroupRounded } from "@solar-icons/react"

const FEATURE_ITEMS = [
  { key: "scheduling" as const, icon: Calendar },
  { key: "customers" as const, icon: UsersGroupRounded },
  { key: "analytics" as const, icon: Chart },
  { key: "payments" as const, icon: Cardholder },
  { key: "reminders" as const, icon: Bell },
  { key: "security" as const, icon: Shield },
  { key: "mobile" as const, icon: Smartphone },
  { key: "booking" as const, icon: Global },
]

export function FeaturesSection() {
  const { t } = useTranslation("marketing")

  return (
    <section className="py-20 sm:py-32 bg-gradient-to-b from-teal-50/50 to-transparent dark:from-teal-950/20 dark:to-transparent">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
            {t("features.title")}
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            {t("features.subtitle")}
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-5xl">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            {FEATURE_ITEMS.map((feature) => (
              <div
                key={feature.key}
                className="relative rounded-lg border bg-background p-6 shadow-sm transition-all hover:shadow-md hover:border-teal-200 dark:hover:border-teal-800"
              >
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-teal-500/10 to-cyan-600/10 text-teal-600">
                  <feature.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-4 font-semibold">{t(`features.items.${feature.key}.name`)}</h3>
                <p className="mt-2 text-sm text-muted-foreground">
                  {t(`features.items.${feature.key}.description`)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
